/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_608_OptionsInputs */



/**
* | output |
* | --- |
* | "608 Options" |
*
* @param {Subtitle_Export_608_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_608_options = /** @type {((inputs?: Subtitle_Export_608_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_608_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("608 options")
	if (locale === "de") return /** @type {LocalizedString} */ ("608 Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("608 Opzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("608 Вариантов")
	if (locale === "es") return /** @type {LocalizedString} */ ("608 Opciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("608 选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("608オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("608 विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("608 Opções")
	return /** @type {LocalizedString} */ ("608 Options")
});